<div class="flex w-full justify-center items-center h-[28px] bg-black z-0">
    <a class="text-[14px] font-bold text-white" href="https://usawink.com" target="_blank">
        Hecho con ❤️ por
        <strong>
            WINK
        </strong>
    </a>
</div>